<template>
  <div>
    <MatchPairSlideOption
      :key="slideOption.order"
      v-for="(slideOption, index) in slideOptions"
      :index="index"
      :slideOption="slideOption"
      :is-deletable="slideOptions.length > 1"
      :handleDeleteSlideOption="handleDeleteSlideOption"
      :handleSlideOptionChanged="handleSlideOptionChanged"
    />

    <AhaButton
      class="w-full"
      icon-name="add"
      @click="addPair"
      v-if="slideOptions.length < 4"
    >
      {{ $i18nPresenter.t('Add Pair') }}
    </AhaButton>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import EventBus from '@/eventBus'

// api
import SlideOptionAPI from '@/api/slideOption'

// components
import MatchPairSlideOption from '@/components-v2/presentation-editor/side-right/MatchPairSlideOption.vue'

export default {
  components: {
    MatchPairSlideOption,
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
      slideOptions: (state) => state.slideActive.SlideOptions,
    }),
  },
  async mounted() {
    if (this.slideOptions.length === 0) {
      const newSlideOptions = [
        {
          title: '',
          pairTitle: '',
          order: 1,
        },
        {
          title: '',
          pairTitle: '',
          order: 2,
        },
        {
          title: '',
          pairTitle: '',
          order: 3,
        },
        {
          title: '',
          pairTitle: '',
          order: 4,
        },
      ]

      this.updateSlideActiveAction({ SlideOptions: newSlideOptions })

      const promises = newSlideOptions.map((item) => SlideOptionAPI.createSlideOption({
        slideId: this.slideActive.id,
        presentationId: this.presentation.id,
        uniqueAccessCode: this.presentation.uniqueAccessCode,
        ...item,
      }))

      try {
        this.setSyncLoadingAction(1)
        const result = await Promise.all(promises)
        this.updateSlideActiveAction({ SlideOptions: result })
        this.setSyncLoadingAction(2)
      } catch {
        this.setSyncLoadingAction(3)
      }
    }
  },
  methods: {
    ...mapActions(['updateSlideActiveAction', 'setSyncLoadingAction']),
    async addPair() {
      if (this.slideOptions.length >= 4) return

      const maxOrder = this.slideOptions.reduce((maxNumber, slideOption) => {
        return slideOption.order > maxNumber ? slideOption.order : maxNumber
      }, 0)

      try {
        this.setSyncLoadingAction(1)
        const newSlideOption = {
          title: '',
          pairTitle: '',
          order: maxOrder + 1,
        }

        this.updateSlideActiveAction({ SlideOptions: [...this.slideOptions, newSlideOption] })

        const slideOption = await SlideOptionAPI.createSlideOption({
          slideId: this.slideActive.id,
          presentationId: this.presentation.id,
          uniqueAccessCode: this.presentation.uniqueAccessCode,
          ...newSlideOption,
        })

        const newSlideOptions = this.slideOptions.map((item) => {
          return item.order === newSlideOption.order ? slideOption : item
        })

        this.updateSlideActiveAction({ SlideOptions: newSlideOptions })
        this.setSyncLoadingAction(2)
      } catch {
        this.setSyncLoadingAction(3)
      }
    },
    async handleDeleteSlideOption(slideOptionId) {
      const newSlideOptions = this.slideOptions
        .filter((item) => item.id !== slideOptionId)

      this.updateSlideActiveAction({ SlideOptions: newSlideOptions })

      try {
        this.setSyncLoadingAction(1)
        await SlideOptionAPI.deleteSlideOption(slideOptionId, {
          presentationId: this.presentation.id,
          uniqueAccessCode: this.presentation.uniqueAccessCode,
        })
        this.setSyncLoadingAction(2)
        EventBus.$emit('match-pairs-change')
      } catch {
        this.setSyncLoadingAction(3)
      }
    },
    async handleSlideOptionChanged(slideOptionId, payload) {
      try {
        this.setSyncLoadingAction(1)
        const newSlideOption = await SlideOptionAPI.patchSlideOptionById(slideOptionId, {
          slideId: this.slideActive.id,
          presentationId: this.presentation.id,
          uniqueAccessCode: this.presentation.uniqueAccessCode,
          ...payload,
        })

        const newSlideOptions = this.slideOptions.map((item) => {
          if (item.id === slideOptionId) {
            return { ...item, ...newSlideOption }
          }
          return item
        })

        this.updateSlideActiveAction({ SlideOptions: newSlideOptions })
        this.setSyncLoadingAction(2)
        EventBus.$emit('match-pairs-change')
      } catch {
        this.setSyncLoadingAction(3)
      }
    },
  },
}
</script>
